import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generateurl',
  templateUrl: './generateurl.component.html',
  styleUrls: ['./generateurl.component.css']
})
export class GenerateurlComponent implements OnInit {
  
  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  requestData = `
  curl -v 'https://api.optimusdrive.ai/vod/v1/customer/multipart/generate-url' \
  -H 'authorization: XXX' \
  --data-raw '{"key_path":"vod/input/bc96e670-4450-42c1-a53c-5175182040e2/ab7b5129-09c0-496f-891b-be082efee32e/6min_1080pVideo.MOV","part_number":1,"upload_id":"XX"}'
  
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }





  sucessData = `
  {
    "data": {
        "url": "https://cmw-optimus-media.s3.amazonaws.com/XXXX”
    },
    "message": "Presign URL generated successfully"
}`

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

}
